export function makeClock(asOfDate, startYear) {
    return Object.freeze({ asOfDate, startYear });
}
//# sourceMappingURL=clock.js.map